export default "__VITE_ASSET__De$t1Bcc__"